export default __webpack_public_path__ + "assets/check_wrong.6ad31a5e.svg";